<template>
<div class="action-buttons profile-contact">
    <template v-if="!loggedOut">
        <template v-if="!currentUser">
            <a :href="user.links.message" class="action-button" @click.prevent="sendMessage(user.userName)">
                <i class="fa fa-2x fa-envelope"></i> {{ t.message }}
            </a>
            <a href="#" class="action-button" @click.prevent="wink">
                <i class="fa fa-2x fa-smile-o"></i> {{ t.wink }}
            </a>
            <a v-if="!dataUser.isFriend" href="#" class="action-button" @click.prevent="friend('add')">
                <i class="fa fa-2x fa-plus"></i> {{ t.friend }}
            </a>
            <a v-if="dataUser.isFriend === 'pendingFromMe'" href="#" class="action-button" @click.prevent="friend('cancel')">
                <i class="fa fa-2x fa-remove"></i> {{ t.friend }}
            </a>
            <template v-if="dataUser.isFriend === 'pendingToMe'">
                <div class="dropdown action-button">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-2x fa-user"></i> {{ t.friend }}
                        <span class="caret"></span>
                   </a>
                   <ul class="dropdown-menu">
                        <li><a href="#" class="action-button" @click.prevent="friend('accept')">
                            <i class="fa fa-2x fa-check"></i> {{ t.accept_request }}
                        </a></li>
                        <li><a href="#" class="action-button" @click.prevent="friend('deny')">
                            <i class="fa fa-2x fa-remove"></i> {{ t.decline_request }}
                        </a></li>
                    </ul>
                </div>
            </template>
            <a v-if="!dataUser.isFavourite" href="#" class="action-button" @click.prevent="favourite('create')">
                <i class="fa fa-2x fa-user-plus"></i> {{ t.follow }}
            </a>
            <a v-if="dataUser.isFavourite" href="#" class="action-button" @click.prevent="favourite('delete')">
                <i class="fa fa-2x fa-user-times"></i> {{ t.unfollow }}
            </a>
            <a href="#" class="action-button" v-if="dataUser.isFriend & showVouchButton & !dataUser.isVouched" @click.prevent="showVouch">
                <i class="fa fa-2x fa-check-circle-o"></i> {{ t.vouch }}
            </a>
        </template>
        <template v-else>
            <a href="#" class="action-button site-invite" @click.prevent="showSiteInvite">
                <i class="fa fa-2x fa-plus"></i> {{ t.site_invite }}
            </a>
        </template>
    </template>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Modal from 'Site/component/Modal.vue';
import Vouch from './Vouch.vue';

import userActions from '../mixin/user.actions';

export default {
    name: 'ProfileHeaderActions',
    components: {
        Modal,
        Vouch
    },
    computed: {
        ...mapState({
            t: state => state.t.profile.profile_header
        }),
        currentUser() {
            return this.user.id === parseInt(this.$store.state.siteConfig.user.id, 10);
        }
    },
    data() {
        return {
            loggedOut: this.$store.state.config.loggedOut || false
        };
    },
    methods: {
        ...mapActions(['sendMessage', 'showSiteInvite']),
        showVouch() {
            this.$emit('show-vouch-modal');
        },
    },
    mixins: [userActions],
    props: {
        user: {
            type: Object,
            required: true
        },
        showVouchButton: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss">

    a.action-button.site-invite {
        width: auto;
    }

</style>
